/* WattWheelz quiz attribution and discovery measurement. GTM must map these dataLayer events to GA4. */
(function(){
 "use strict";
 const ready=()=>{
  const path=window.location.pathname;
  const save=(k,v,onlyIfAbsent)=>{try{if(!onlyIfAbsent||!sessionStorage.getItem(k))sessionStorage.setItem(k,v)}catch(_){}};
  const get=k=>{try{return sessionStorage.getItem(k)||""}catch(_){return""}};
  const emit=(event,extra={})=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...extra})};
  save("ww_quiz_first_page",window.location.pathname,true);
  ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","gclid","msclkid","fbclid"].forEach(key=>{const v=new URLSearchParams(window.location.search).get(key);if(v)save("ww_quiz_"+key,v,false)});
  const source=link=>link.dataset.wwQuizSurface||
    (link.closest(".ww-mobile-menu")?"mobile_menu":
     link.closest(".ww-header")?"desktop_header":
     link.closest(".ww-hero")?"home_hero":
     link.closest(".ww-footer")?"footer":
     path.startsWith("/products/")?"pdp_other":
     path.startsWith("/collections/")?"collection_other":"other");
  const links=[...document.querySelectorAll('a[href*="/pages/find-my-ebike"]')].filter(a=>a.pathname==="/pages/find-my-ebike");
  const seen=new Set();
  if("IntersectionObserver" in window){
   const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(!entry.isIntersecting)return;const a=entry.target;const key=source(a)+":"+path;if(!seen.has(key)){seen.add(key);emit("quiz_cta_impression",{quiz_cta_surface:source(a),quiz_entry_path:path})}observer.unobserve(a)})
   },{threshold:0.5});
   links.forEach(a=>observer.observe(a));
  }
  document.addEventListener("click",e=>{
    const link=e.target.closest('a[href*="/pages/find-my-ebike"]');
    if(!link||link.pathname!=="/pages/find-my-ebike")return;
    const surface=source(link);
    save("ww_quiz_entry_page",path,false);
    save("ww_quiz_entry_surface",surface,false);
    emit("quiz_cta_click",{quiz_cta_surface:surface,quiz_entry_path:path});
  },true);
 };
 document.readyState==="loading"?document.addEventListener("DOMContentLoaded",ready):ready();
})();
